
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'billing-portal-ui',
  currentProjectVersion: 'static-1.2022',
  depVersions: {
  "billing-portal-ui": "static-1.2022",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.493",
  "foundations-components-test-utils": "static-1.5895",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8283",
  "hub-http-shared-msw-handlers": "static-1.10545",
  "hubspot-dlb": "static-2.1882",
  "react-dlb": "static-1.85",
  "reselect": "static-3.9",
  "billing-portal-service-types": "static-1.1860",
  "commerce-products-lib": "static-1.10435",
  "commerce-shared-components-lib": "static-1.19147",
  "customer-data-objects": "static-1.7944",
  "customer-data-properties": "static-1.52464",
  "customer-data-property-utils": "static-1.8355",
  "data-fetching-client": "static-1.9914",
  "foundations-assets": "static-1.5140",
  "foundations-components": "static-1.8412",
  "foundations-theming": "static-1.4722",
  "framework-data-table": "static-2.12472",
  "hub-http": "static-1.6470",
  "HubStyleTokens": "static-2.11740",
  "I18n": "static-7.1664",
  "meetings-icalendar-utils-lib": "static-1.892",
  "metrics-js": "static-1.9867",
  "object-builder-ui-client": "static-1.49572",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1365",
  "property-translator": "static-1.5654",
  "purchase-motions-components": "static-1.6295",
  "quartz-config": "static-1.1169",
  "quartz-core": "static-1.6610",
  "quartz-routing": "static-1.821",
  "quick-fetch": "static-1.4101",
  "raven": "static-3.5925",
  "react": "static-7.191",
  "react-dom": "static-7.85",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.16968",
  "redux": "static-4.76",
  "redux-toolkit": "static-1.75",
  "rpc-client-utils": "static-1.4919",
  "sanitize-text": "static-1.8407",
  "smart-property-lib": "static-1.8197",
  "styled-components": "static-2.95",
  "ui-addon-form-validation": "static-1.11242",
  "ui-addon-i18n": "static-1.11400",
  "ui-addon-iframeable": "static-1.9331",
  "ui-addon-react-router-dom": "static-1.9793",
  "ui-addon-upgrades": "static-9.18329",
  "UIComponents": "static-3.8686",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "immutable": "static-2.83",
  "bend-plugin-trellis-migration": "static-1.3587",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3668",
  "quartz-webpack": "static-1.3615",
  "bend-plugin-quartz-routing": "static-1.469",
  "foundations-components-legacy": "static-1.1437",
  "HeadJS": "static-2.790",
  "quartz": "static-1.7391",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3394",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "ts-schema": "static-1.4263",
  "webpack-env": "static-1.54",
  "commerce-permissions": "static-1.1033",
  "customer-data-tracking": "static-1.7138",
  "framework-data-schema-resolvers": "static-1.7149",
  "growth-payments-core": "static-1.26098",
  "hubspot-apollo-client": "static-1.5135",
  "immer": "static-1.94",
  "products-iframe-lib": "static-1.8517",
  "products-ui-components-shared-msw-handlers": "static-1.10927",
  "transmute": "static-2.85",
  "batch-promise": "static-1.1797",
  "crm_data": "static-4.92748",
  "cssUtils": "static-1.874",
  "customer-data-associations": "static-1.7584",
  "customer-data-objects-ui-components": "static-1.13286",
  "frontend-preferences-client": "static-1.8183",
  "graphql": "static-1.86",
  "hs-lodash": "static-4.45",
  "hs-story-utils": "static-1.9683",
  "HubStyle": "static-2.12047",
  "icons": "static-2.675",
  "payments-enrollment-embed-lib": "static-1.23725",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5524",
  "stripe-embedded-components": "static-1.7939",
  "StyleGuideUI": "static-3.496",
  "ui-addon-opt": "static-4.8622",
  "ui-images": "static-2.1232",
  "usage-tracker-container": "static-1.7603",
  "usage-tracker-core": "static-1.7463",
  "inbound-db-properties-service-client": "static-1.4026",
  "ai-components-ui-library": "static-1.9622",
  "atom": "static-1.5342",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2751",
  "calling-global-api": "static-1.65423",
  "calling-internal-common": "static-1.31575",
  "calling-lifecycle-internal": "static-1.66805",
  "calling-lifecycle-messages": "static-1.59099",
  "conditional-properties-service-client": "static-1.3983",
  "crm-index-visualization-core": "static-1.4486",
  "crm-links": "static-1.6582",
  "crm-message-bus": "static-1.43667",
  "crm-pipelines-api-client-types": "static-1.4317",
  "customer-data-properties-shared-msw-handlers": "static-1.9872",
  "external-options-client-types": "static-1.4309",
  "file-manager-components": "static-1.24391",
  "formula-editor": "static-1.14689",
  "google-libphonenumber": "static-1.42",
  "hs-promise-utils": "static-1.5852",
  "hs-resources": "static-1.447",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4394",
  "multi-currency-client-types": "static-1.3878",
  "PatternValidationJS": "static-1.3154",
  "pipeline-validation-client-types": "static-1.4151",
  "property-value-citations": "static-1.3078",
  "pulse": "static-1.881",
  "quartz-i18n": "static-1.1066",
  "reference-resolvers-lite": "static-1.8357",
  "SharedI18nStrings": "static-1.182",
  "smart-data-capture-core": "static-1.50",
  "tiered-pricing": "static-1.1888",
  "trial-components-library": "static-1.14040",
  "topics-actions-lib": "static-1.421",
  "usage-tracker": "static-1.7613",
  "user-context": "static-1.5373",
  "zustand": "static-1.79",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4681",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2438",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.63",
  "react-virtualized": "static-2.104",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2510",
  "ui-fonts": "static-1.1002",
  "bend-plugin-foundations-theming": "static-1.3205",
  "foundations-theming-base": "static-1.3707",
  "stylex": "static-1.38",
  "customer-data-reference-ui-components": "static-1.13436",
  "customer-data-ui-utilities": "static-1.10084",
  "tasks-actions-lib": "static-1.42",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "redux-thunk": "static-2.77",
  "reference-resolvers": "static-1.8436",
  "reporting-data": "static-1.68644",
  "sanitize": "static-1.4732",
  "tanstack-virtual": "static-1.36",
  "ui-addon-draggable": "static-3.5012",
  "hs-locale-management": "static-1.262",
  "i18n-data": "static-1.227",
  "moment-timezone": "static-5.87",
  "interframe": "static-3.5012",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6027",
  "merchandise-lib": "static-1.273",
  "onboarding-scopes": "static-1.6711",
  "purchase-motions-api": "static-1.6298",
  "signup-constants": "static-1.19530",
  "signup-ui-url-generator": "static-2.8316",
  "opentelemetry-fe-types": "static-1.27",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.870",
  "hubspotter-http": "static-1.4832",
  "jasmine": "static-4.4573",
  "jasmine-runner": "static-1.6706",
  "mobile-manifest-mixins": "static-1.568",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.402",
  "quartz-auth": "static-1.1066",
  "quartz-head": "static-1.1056",
  "quartz-test": "static-1.1066",
  "quartz-tracking": "static-1.770",
  "trellis-components": "static-1.2529",
  "csstype": "static-1.50",
  "web-vitals": "static-1.11",
  "bend-plugin-chirp-manifest": "static-1.329",
  "chirp-fetch": "static-1.2150",
  "data-agent-kit": "static-1.587",
  "data-token-picker": "static-1.16829",
  "feedback-loader": "static-1.29749",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10628",
  "fsm": "static-1.3997",
  "policy-lib": "static-1.7053",
  "react-colorpicker": "static-2.10464",
  "react-tinymce": "static-1.55899",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10691",
  "rich-text-lib": "static-1.20247",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55025",
  "tinymce-plugins": "static-1.58139",
  "tinymce-themes": "static-1.56995",
  "magpie-lib": "static-1.5724",
  "navigation-messaging": "static-1.8060",
  "laboratory-lib": "static-3.7409",
  "salesImages": "static-1.531",
  "bender-build-tools": "static-1.3382",
  "fdsr-migration-layer": "static-1.268",
  "framework-builder-read-service-client": "static-1.4190",
  "framework-data-schema-quick-fetch": "static-1.7054",
  "persist-promise": "static-1.3954",
  "seat-types-lib": "static-1.650",
  "apollo-link-hub-http": "static-2.4912",
  "hubspot-apollo-cache": "static-1.594",
  "sales-views-client-types": "static-1.4513",
  "crm_universal": "static-1.22439",
  "customer-data-email": "static-1.18466",
  "native-integrations-shared-strings": "static-1.8034",
  "superstore": "static-1.5012",
  "sassPrefix": "static-1.162",
  "copilot-toolkit": "static-1.11767",
  "growth-onboarding-confetti": "static-1.3319",
  "growth-onboarding-feedback-components": "static-1.6841",
  "growth-onboarding-reliability": "static-1.5337",
  "marketplace-ui-apps-core": "static-1.19160",
  "onboarding-tours": "static-1.17057",
  "stripe-connect-js": "static-1.74",
  "chatspot-core": "static-1.22704",
  "ContentUtils": "static-1.69063",
  "calling-error-reporting": "static-1.31582",
  "shared-worker-versioning": "static-1.11296",
  "calling-usage-tracker": "static-1.6795",
  "voice-sms-access-library": "static-1.1934",
  "conversations-skeleton-state": "static-1.7505",
  "react-immutable-render-mixin": "static-1.9",
  "crm-index-associations-lib": "static-1.6699",
  "location-customization-utils-lib": "static-1.10013",
  "restore-request-side-panel-lib": "static-1.1583",
  "breeze-engine-lib": "static-1.1600",
  "immerable": "static-1.4408",
  "video-components-external": "static-1.12082",
  "video-data-lib": "static-1.35740",
  "bark-lib": "static-1.16763",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6146",
  "react-codemirror": "static-1.10896",
  "event-emitter": "static-1.1210",
  "bend-plugin-pulse": "static-1.384",
  "fast-json-patch": "static-1.67",
  "embedded-academy-lib": "static-1.15400",
  "hubs-service-types": "static-1.1515",
  "getting-started-shared-tasks": "static-1.19139",
  "getting-started-shared-tasks-store": "static-1.18257",
  "onboarding-tours-utils": "static-1.1123",
  "react-dnd-compat": "static-1.4872",
  "reporting-client-types": "static-1.2652",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.75",
  "usage-tracker-anonymous": "static-1.6030",
  "usage-tracker-public": "static-1.7424",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10543",
  "usage-tracker-session-replay": "static-1.5299",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1223",
  "highcharts": "static-8.108",
  "trellis-story-utils": "static-1.4767",
  "storybook-react": "static-1.37",
  "FileManagerLib": "static-1.40031",
  "hub-http-contrib": "static-1.3294",
  "tinymce-data": "static-1.41110",
  "ui-addon-sales-email": "static-1.5472",
  "content-assistance-lib": "static-1.8144",
  "FileManagerCore": "static-1.39890",
  "layout-dnd-components": "static-1.12904",
  "layout-dnd-utils": "static-1.11879",
  "ui-addon-emoji-picker": "static-1.10142",
  "ui-brand-identity-lib": "static-1.16272",
  "NamespacedHubStyle": "static-2.9231",
  "idb-keyval": "static-1.48",
  "magpie-types": "static-1.5184",
  "reactive-lib": "static-1.978",
  "simple-logging-lib": "static-1.3307",
  "FormUrlGenerator": "static-2.4983",
  "sequences-lib": "static-1.8478",
  "timezone-utils": "static-2.5504",
  "ui-gdpr-components": "static-1.10613",
  "developer-experience-shared-components": "static-1.10759",
  "immutable-less": "static-1.4907",
  "marketplace-ui-client-types": "static-1.18035",
  "marketplace-ui-common": "static-1.20628",
  "ui-addon-integrations-directory-panel": "static-2.8283",
  "ui-extensibility-client-types": "static-1.4177",
  "ui-universal-auth": "static-1.9315",
  "growth-data-modal": "static-1.5834",
  "growth-onboarding-next-action-utils": "static-1.2617",
  "navigation-components": "static-1.18733",
  "onboarding-tours-client": "static-1.5271",
  "ui-shepherd-react": "static-3.10521",
  "ui-shepherd-tracker": "static-1.7902",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.5071",
  "content-icons-ui": "static-1.2321",
  "integrations-lib": "static-1.16951",
  "underscore": "static-1.8",
  "calling-orchestration-schema": "static-1.36711",
  "crm-record-cards-service-types": "static-1.3759",
  "breeze-engine-chat-components": "static-1.578",
  "breeze-engine-core": "static-1.878",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "content-media-composition-data-lib": "static-1.13142",
  "content-media-compositions": "static-2.17149",
  "media-bridge-lib": "static-1.19349",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16288",
  "browser-eslint": "static-2.57",
  "academy-common-lib": "static-1.14860",
  "amplitude-session-replay-browser": "static-1.60",
  "audio-components": "static-1.6285",
  "FileManagerImages": "static-1.37542",
  "video-components": "static-1.14084",
  "ui-addon-video-player": "static-1.8960",
  "ui-coaching-tips": "static-1.29236",
  "breeze-artifacts-sdk": "static-1.220",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4789",
  "video-embed": "static-1.36574",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10204",
  "emoji-mart": "static-3.4",
  "prosemirror": "static-1.13",
  "sequences-client-types-lib": "static-1.8335",
  "apps-service-types": "static-1.3998",
  "oauth-service-types": "static-1.4507",
  "ai-settings-ui-library": "static-1.8268",
  "nav-meta": "static-1.30370",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.910",
  "unified-auth-core-lib": "static-1.1111",
  "onboarding-data-sync-lib": "static-1.2433",
  "growth-onboarding-next-action-components": "static-1.2645",
  "user-context-client": "static-1.4765",
  "nest": "static-1.492",
  "flux-actions": "static-1.361",
  "integrations-error-boundary-lib": "static-1.14366",
  "integrations-tracking-lib": "static-1.5865",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10624",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.829",
  "academy-service-client": "static-1.3945",
  "croppie": "static-2.10",
  "final-form": "static-1.75",
  "SafeStorage": "static-1.4661",
  "trellis-ecosystem": "static-1.7575",
  "wootric-nps": "static-1.7168",
  "social-insights-client-types": "static-1.22685",
  "outpost": "static-1.4417",
  "advanced-menus-core": "static-1.15521",
  "advanced-menus-lib": "static-1.12400",
  "ExportDialog": "static-6.10635",
  "ui-memberships-settings-lib": "static-1.34763",
  "simple-data-table": "static-1.3458",
  "InboxConnectUtils": "static-4.15479",
  "meetings-connect-utils-lib": "static-1.7866",
  "universal-page-editor-lib": "static-1.3264",
  "adobe-sign-auth-lib": "static-1.376",
  "ads-unified-auth-lib": "static-1.1126",
  "google-sheets-integration-lib": "static-1.952",
  "microsoft-drive-auth-lib": "static-1.49",
  "surveymonkey-integration-lib": "static-1.396",
  "slack-ui-library": "static-1.10655",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15520",
  "simple-menus-lib": "static-1.17037"
},
  depPathPrefixes: {
  "billing-portal-ui": "/billing-portal-ui/static-1.2022",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.493",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5895",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8283",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10545",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "react-dlb": "/react-dlb/static-1.85",
  "reselect": "/reselect/static-3.9",
  "billing-portal-service-types": "/billing-portal-service-types/static-1.1860",
  "commerce-products-lib": "/commerce-products-lib/static-1.10435",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19147",
  "customer-data-objects": "/customer-data-objects/static-1.7944",
  "customer-data-properties": "/customer-data-properties/static-1.52464",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8355",
  "data-fetching-client": "/data-fetching-client/static-1.9914",
  "foundations-assets": "/foundations-assets/static-1.5140",
  "foundations-components": "/foundations-components/static-1.8412",
  "foundations-theming": "/foundations-theming/static-1.4722",
  "framework-data-table": "/framework-data-table/static-2.12472",
  "hub-http": "/hub-http/static-1.6470",
  "HubStyleTokens": "/HubStyleTokens/static-2.11740",
  "I18n": "/I18n/static-7.1664",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.892",
  "metrics-js": "/metrics-js/static-1.9867",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49572",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1365",
  "property-translator": "/property-translator/static-1.5654",
  "purchase-motions-components": "/purchase-motions-components/static-1.6295",
  "quartz-config": "/quartz-config/static-1.1169",
  "quartz-core": "/quartz-core/static-1.6610",
  "quartz-routing": "/quartz-routing/static-1.821",
  "quick-fetch": "/quick-fetch/static-1.4101",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.191",
  "react-dom": "/react-dom/static-7.85",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.16968",
  "redux": "/redux/static-4.76",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "rpc-client-utils": "/rpc-client-utils/static-1.4919",
  "sanitize-text": "/sanitize-text/static-1.8407",
  "smart-property-lib": "/smart-property-lib/static-1.8197",
  "styled-components": "/styled-components/static-2.95",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11242",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11400",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9331",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9793",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18329",
  "UIComponents": "/UIComponents/static-3.8686",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "immutable": "/immutable/static-2.83",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3587",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3668",
  "quartz-webpack": "/quartz-webpack/static-1.3615",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.469",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1437",
  "HeadJS": "/HeadJS/static-2.790",
  "quartz": "/quartz/static-1.7391",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3394",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "ts-schema": "/ts-schema/static-1.4263",
  "webpack-env": "/webpack-env/static-1.54",
  "commerce-permissions": "/commerce-permissions/static-1.1033",
  "customer-data-tracking": "/customer-data-tracking/static-1.7138",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7149",
  "growth-payments-core": "/growth-payments-core/static-1.26098",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5135",
  "immer": "/immer/static-1.94",
  "products-iframe-lib": "/products-iframe-lib/static-1.8517",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10927",
  "transmute": "/transmute/static-2.85",
  "batch-promise": "/batch-promise/static-1.1797",
  "crm_data": "/crm_data/static-4.92748",
  "cssUtils": "/cssUtils/static-1.874",
  "customer-data-associations": "/customer-data-associations/static-1.7584",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13286",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8183",
  "graphql": "/graphql/static-1.86",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-story-utils": "/hs-story-utils/static-1.9683",
  "HubStyle": "/HubStyle/static-2.12047",
  "icons": "/icons/static-2.675",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23725",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5524",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7939",
  "StyleGuideUI": "/StyleGuideUI/static-3.496",
  "ui-addon-opt": "/ui-addon-opt/static-4.8622",
  "ui-images": "/ui-images/static-2.1232",
  "usage-tracker-container": "/usage-tracker-container/static-1.7603",
  "usage-tracker-core": "/usage-tracker-core/static-1.7463",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4026",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9622",
  "atom": "/atom/static-1.5342",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2751",
  "calling-global-api": "/calling-global-api/static-1.65423",
  "calling-internal-common": "/calling-internal-common/static-1.31575",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66805",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59099",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3983",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4486",
  "crm-links": "/crm-links/static-1.6582",
  "crm-message-bus": "/crm-message-bus/static-1.43667",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4317",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9872",
  "external-options-client-types": "/external-options-client-types/static-1.4309",
  "file-manager-components": "/file-manager-components/static-1.24391",
  "formula-editor": "/formula-editor/static-1.14689",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "hs-promise-utils": "/hs-promise-utils/static-1.5852",
  "hs-resources": "/hs-resources/static-1.447",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4394",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3878",
  "PatternValidationJS": "/PatternValidationJS/static-1.3154",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4151",
  "property-value-citations": "/property-value-citations/static-1.3078",
  "pulse": "/pulse/static-1.881",
  "quartz-i18n": "/quartz-i18n/static-1.1066",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8357",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.50",
  "tiered-pricing": "/tiered-pricing/static-1.1888",
  "trial-components-library": "/trial-components-library/static-1.14040",
  "topics-actions-lib": "/topics-actions-lib/static-1.421",
  "usage-tracker": "/usage-tracker/static-1.7613",
  "user-context": "/user-context/static-1.5373",
  "zustand": "/zustand/static-1.79",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4681",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2438",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.63",
  "react-virtualized": "/react-virtualized/static-2.104",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2510",
  "ui-fonts": "/ui-fonts/static-1.1002",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3205",
  "foundations-theming-base": "/foundations-theming-base/static-1.3707",
  "stylex": "/stylex/static-1.38",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13436",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10084",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.42",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reference-resolvers": "/reference-resolvers/static-1.8436",
  "reporting-data": "/reporting-data/static-1.68644",
  "sanitize": "/sanitize/static-1.4732",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5012",
  "hs-locale-management": "/hs-locale-management/static-1.262",
  "i18n-data": "/i18n-data/static-1.227",
  "moment-timezone": "/moment-timezone/static-5.87",
  "interframe": "/interframe/static-3.5012",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6027",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "onboarding-scopes": "/onboarding-scopes/static-1.6711",
  "purchase-motions-api": "/purchase-motions-api/static-1.6298",
  "signup-constants": "/signup-constants/static-1.19530",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8316",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.27",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.870",
  "hubspotter-http": "/hubspotter-http/static-1.4832",
  "jasmine": "/jasmine/static-4.4573",
  "jasmine-runner": "/jasmine-runner/static-1.6706",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.568",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.402",
  "quartz-auth": "/quartz-auth/static-1.1066",
  "quartz-head": "/quartz-head/static-1.1056",
  "quartz-test": "/quartz-test/static-1.1066",
  "quartz-tracking": "/quartz-tracking/static-1.770",
  "trellis-components": "/trellis-components/static-1.2529",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.329",
  "chirp-fetch": "/chirp-fetch/static-1.2150",
  "data-agent-kit": "/data-agent-kit/static-1.587",
  "data-token-picker": "/data-token-picker/static-1.16829",
  "feedback-loader": "/feedback-loader/static-1.29749",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10628",
  "fsm": "/fsm/static-1.3997",
  "policy-lib": "/policy-lib/static-1.7053",
  "react-colorpicker": "/react-colorpicker/static-2.10464",
  "react-tinymce": "/react-tinymce/static-1.55899",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10691",
  "rich-text-lib": "/rich-text-lib/static-1.20247",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55025",
  "tinymce-plugins": "/tinymce-plugins/static-1.58139",
  "tinymce-themes": "/tinymce-themes/static-1.56995",
  "magpie-lib": "/magpie-lib/static-1.5724",
  "navigation-messaging": "/navigation-messaging/static-1.8060",
  "laboratory-lib": "/laboratory-lib/static-3.7409",
  "salesImages": "/salesImages/static-1.531",
  "bender-build-tools": "/bender-build-tools/static-1.3382",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.268",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4190",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7054",
  "persist-promise": "/persist-promise/static-1.3954",
  "seat-types-lib": "/seat-types-lib/static-1.650",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4912",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.594",
  "sales-views-client-types": "/sales-views-client-types/static-1.4513",
  "crm_universal": "/crm_universal/static-1.22439",
  "customer-data-email": "/customer-data-email/static-1.18466",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8034",
  "superstore": "/superstore/static-1.5012",
  "sassPrefix": "/sassPrefix/static-1.162",
  "copilot-toolkit": "/copilot-toolkit/static-1.11767",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3319",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6841",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5337",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19160",
  "onboarding-tours": "/onboarding-tours/static-1.17057",
  "stripe-connect-js": "/stripe-connect-js/static-1.74",
  "chatspot-core": "/chatspot-core/static-1.22704",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "calling-error-reporting": "/calling-error-reporting/static-1.31582",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11296",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6795",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1934",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7505",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6699",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10013",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1583",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1600",
  "immerable": "/immerable/static-1.4408",
  "video-components-external": "/video-components-external/static-1.12082",
  "video-data-lib": "/video-data-lib/static-1.35740",
  "bark-lib": "/bark-lib/static-1.16763",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6146",
  "react-codemirror": "/react-codemirror/static-1.10896",
  "event-emitter": "/event-emitter/static-1.1210",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.384",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15400",
  "hubs-service-types": "/hubs-service-types/static-1.1515",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19139",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18257",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1123",
  "react-dnd-compat": "/react-dnd-compat/static-1.4872",
  "reporting-client-types": "/reporting-client-types/static-1.2652",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.75",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6030",
  "usage-tracker-public": "/usage-tracker-public/static-1.7424",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10543",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5299",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1223",
  "highcharts": "/highcharts/static-8.108",
  "trellis-story-utils": "/trellis-story-utils/static-1.4767",
  "storybook-react": "/storybook-react/static-1.37",
  "FileManagerLib": "/FileManagerLib/static-1.40031",
  "hub-http-contrib": "/hub-http-contrib/static-1.3294",
  "tinymce-data": "/tinymce-data/static-1.41110",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5472",
  "content-assistance-lib": "/content-assistance-lib/static-1.8144",
  "FileManagerCore": "/FileManagerCore/static-1.39890",
  "layout-dnd-components": "/layout-dnd-components/static-1.12904",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11879",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10142",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16272",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9231",
  "idb-keyval": "/idb-keyval/static-1.48",
  "magpie-types": "/magpie-types/static-1.5184",
  "reactive-lib": "/reactive-lib/static-1.978",
  "simple-logging-lib": "/simple-logging-lib/static-1.3307",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4983",
  "sequences-lib": "/sequences-lib/static-1.8478",
  "timezone-utils": "/timezone-utils/static-2.5504",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10613",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10759",
  "immutable-less": "/immutable-less/static-1.4907",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18035",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20628",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8283",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4177",
  "ui-universal-auth": "/ui-universal-auth/static-1.9315",
  "growth-data-modal": "/growth-data-modal/static-1.5834",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2617",
  "navigation-components": "/navigation-components/static-1.18733",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5271",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10521",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7902",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.5071",
  "content-icons-ui": "/content-icons-ui/static-1.2321",
  "integrations-lib": "/integrations-lib/static-1.16951",
  "underscore": "/underscore/static-1.8",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36711",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.578",
  "breeze-engine-core": "/breeze-engine-core/static-1.878",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13142",
  "content-media-compositions": "/content-media-compositions/static-2.17149",
  "media-bridge-lib": "/media-bridge-lib/static-1.19349",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16288",
  "browser-eslint": "/browser-eslint/static-2.57",
  "academy-common-lib": "/academy-common-lib/static-1.14860",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "audio-components": "/audio-components/static-1.6285",
  "FileManagerImages": "/FileManagerImages/static-1.37542",
  "video-components": "/video-components/static-1.14084",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8960",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29236",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.220",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4789",
  "video-embed": "/video-embed/static-1.36574",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10204",
  "emoji-mart": "/emoji-mart/static-3.4",
  "prosemirror": "/prosemirror/static-1.13",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8335",
  "apps-service-types": "/apps-service-types/static-1.3998",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8268",
  "nav-meta": "/nav-meta/static-1.30370",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.910",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1111",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2433",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2645",
  "user-context-client": "/user-context-client/static-1.4765",
  "nest": "/nest/static-1.492",
  "flux-actions": "/flux-actions/static-1.361",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14366",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5865",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10624",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.829",
  "academy-service-client": "/academy-service-client/static-1.3945",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.75",
  "SafeStorage": "/SafeStorage/static-1.4661",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7575",
  "wootric-nps": "/wootric-nps/static-1.7168",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "outpost": "/outpost/static-1.4417",
  "advanced-menus-core": "/advanced-menus-core/static-1.15521",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12400",
  "ExportDialog": "/ExportDialog/static-6.10635",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34763",
  "simple-data-table": "/simple-data-table/static-1.3458",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15479",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7866",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3264",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.376",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1126",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.952",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.49",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.396",
  "slack-ui-library": "/slack-ui-library/static-1.10655",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15520",
  "simple-menus-lib": "/simple-menus-lib/static-1.17037"
}
};
